import { PatchNotes } from "../../types/patches";

export const patch: PatchNotes = {
  id: "patch-5.0.7989",
  buildId: "5.0.7989",
  name: "Patch 7989",
  season: 0,
  type: "patch",
  officialUrl: "https://www.ageofempires.com/news/age-of-empires-iv-patch-7989",
  summary: "",
  introduction: `
![](https://www.ageofempires.com/wp-content/uploads/2021/11/PatchNote2-1080x608.jpg)
""`,
  date: new Date("2021-11-03T17:57:29Z"),
  sections: [

  ],
};
